import React, { useEffect, useRef, useState } from 'react';
import * as R from "ramda";
import { useDispatch } from 'react-redux';
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router';


import { fetchAllClients } from '../../actions/backoffice/clients';
import { LoadingState } from '../../_common/loadingState';
import * as Loadings from '../../constants/loadings/backoffice/clients';


import { ClientsMain } from './main';
// import { ClientsDetail } from './detail';

export const Clients = ({ clientsState }) => {

	const dispatch = useDispatch();
	const searchQuery = useLocation();

	const pageQuery = new URLSearchParams(searchQuery.search);
	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let roles = pageQuery.get('roles');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	roles = R.isNil(roles) ? "" : roles;
	sortBy = R.isNil(sortBy) ? "creationDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;

	const [pageSearch, setPageSearch] = useState(search);
	const renderRef = useRef(false);
	const history = useHistory();

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push("/backoffice/clients");
			return;
		}

		//pageNumber, searchTerm,roles, sortByTerm, sortDesc
		dispatch(fetchAllClients(page, search, roles, sortBy, sortDesc));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery.search, history.location]);


	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};

		if (R.isEmpty(pageSearch)) {
			history.push(`/backoffice/clients?page=${1}${roles !== "" ? "&roles=" + roles : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${routerQuery.sortDesc !== "" ? "&sortDesc=" + routerQuery.sortDesc : ""}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(fetchAllClients(page, pageSearch, roles, sortBy, sortDesc));
		}, 1000);


		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);



	if (clientsState.isLoading.includes(Loadings.FETCHING_CLIENTS) && R.isNil(clientsState.clients)) {
		return <LoadingState />;
	}


	if (R.isNil(clientsState.clients)) {
		return '';
	}

	const routerQuery = {
		page,
		search,
		roles,
		sortBy,
		sortDesc,
	};


	return (
		<Switch>
			<Route exact path="/backoffice/clients" >
				<ClientsMain clientsState={clientsState} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} />
			</Route>
			{/* <Route path="/backoffice/clients/:user" component={ClientsDetail} /> */}
			<Route render={() => {
				return <Redirect exact to="/backoffice/clients" />;
			}} />
		</Switch>
	);

};

